import { environment } from '../../browser';
const environmentToHostMap = {
    ontw: 'api-ontw',
    test: 'api-test',
    acc: 'api-acc',
    prod: 'api',
};
/**
 * This will return the correct base url for the api based on the current host url
 * @return The base url for the api based on the current host
 */
export const getHost = () => environmentToHostMap[environment];
